import { render } from "./IconDownload.vue?vue&type=template&id=09e68120"
const script = {}

import "./IconDownload.vue?vue&type=style&index=0&id=09e68120&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__